<template>
    <div>
        <b-container fluid>
            <b-jumbotron fluid class="jumbo">
                <template v-slot:header >Fecal microbiota transplant (FMT) database</template>
                <template v-slot:lead>
                A database of ....
                </template>

                <hr class="my-4">
                <p>Fecal microbiota transplant (FMT) of human fecal samples to germ-free (GF) mice is useful for establishing causal relationships between gut microbiota and human phenotypes. </p>

            </b-jumbotron>
            <b-row>
                <b-container>
                    <b-row>
                        <b-col sm="6" md="12" lg="6" >
                            <b-card>
                            <Plotly :data="graphData" :layout="layout" :display-mode-bar="false" :autoResize="true"></Plotly>
                            </b-card>
                        </b-col>
                        <b-col sm="6" md="12" lg="6"  class="ml-auto">
                            <b-card title="" align=justify>
                                <b-card-text>
                                    We collected data from in total 1,713 human-to-mouse FMT experiments and analyzed the relative microbe abundances in fecal samples of the human donors and the corresponding germ-free mouse recipients (Materials and Methods). 
                                </b-card-text>
                                <b-card-text>
                                    For each human-to-mouse pair, we computed the relative abundance changes before and after FMT. We first checked how many gut microbes could be re-established in mice after FMT. We limited our analysis to taxa that were supported by at least five sequencing reads in both samples of the human-mouse pairs.
                                </b-card-text>
                                <b-card-text>
                                47% and 60% human gut microbes could be re-established in mouse gut after FMT at species (red) and genus (blue) levels respectively.
We limited our analysis to taxa that were supported by at least five sequencing reads in both samples in each of the human-mouse pairs.</b-card-text>

                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row>
                        <br/>
                    </b-row>
                </b-container>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data () {
        return{
            server_add:this.$hostname,
            graphData:[
            ],
            layout:{
                title: "Retention rate density plot",
                xaxis: {
                    title: {
                        text:"Retention rate"
                    }
                },
                yaxis: {
                    title: {
                        text:"Density"
                    }
                }
            }
        }
    },
    mounted() {
        // this.graphData[0].y = [20,30,10,5]
        this.loadAllRetentionRates()
    },
    methods: {
        loadAllRetentionRates(){
            axios.post(this.server_add+'query/getAllRetDensity',
            {
            }).then(retDat => {
                console.log(retDat)
                if(retDat.status == 200){
                    //this.graphData[0].y
                    var genus = {
                        x:retDat.data.genus.x,
                        y:retDat.data.genus.y,
                        name:'Genus',
                        mode: 'lines+markers',
                        type:"scatter"                        
                    }
                    var species = {
                        x:retDat.data.species.x,
                        y:retDat.data.species.y,
                        name:'Species',
                        mode: 'lines+markers',
                        type:"scatter"
                    }
                    // console.log(genus.x)
                    this.graphData.push(genus)
                    this.graphData.push(species)
                    // this.graphData[0].y = genus.y
                    // this.graphData[1].x = species.x
                    // this.graphData[1].y = species.y
                }
            }).catch(err => {
                console.log(err)
            })
        }
    },
}

</script>


<style scoped lang = "less">
   .jumbo{
       text-align: left;

       p{
            font-size: 0.9em;
        }

        h1{
            font-size: 2.0em;
        }
   } 
</style>

